import dayjs from "dayjs";

// Hooks
import useTranslate from "hooks/useTranslate";

// Types
import { MethodType, TRANSACTION_STATUS } from "types/Transaction";

import "./styles.sass";

export type TransactionDescriptionProps = {
  id: number | string;
  status: TRANSACTION_STATUS;
  method: MethodType;
  createdAt: string;
  updatedAt: string;
  remoteId: string;
  isPayment: boolean;
};

const TransactionDescription = (props: TransactionDescriptionProps) => {
  const { status, id, method, remoteId, createdAt, updatedAt, isPayment } =
    props;
  const stringId = id.toString();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const t = useTranslate();
  const nameCasino = VITE_APP_PROJECT_NAME === "glory" ? "Glory" : "Banger";

  return (
    <div className="TransactionDescription">
      <div className="TransactionDescription__item">
        <span>
          {t("profile.balance.history.id")} {nameCasino}
        </span>
        <span className="TransactionDescription__item-id" title={stringId}>
          {stringId}
        </span>
      </div>
      {isPayment && (
        <div className="TransactionDescription__item">
          <span>
            {t("profile.balance.history.id")} {method ? method.name : ""}
          </span>
          <span>{remoteId}</span>
        </div>
      )}
      <div className="TransactionDescription__item">
        <span>{t("profile.balance.history.created.long")}</span>
        <span>{dayjs(createdAt).format("HH:mm DD/MM")}</span>
      </div>
      {isPayment && (
        <div className="TransactionDescription__item">
          <span>{t("profile.balance.history.confirmed.long")}</span>
          <span>
            {status === TRANSACTION_STATUS.SUCCESS
              ? dayjs(updatedAt).format("HH:mm DD/MM")
              : "n/a"}
          </span>
        </div>
      )}
    </div>
  );
};

export default TransactionDescription;
